import {
  createValidation,
  validatorRequired,
  validatorNumber,
  validatorZip,
} from '../../utils/formValidators';

import { formRegisterMeasurementFields } from '../../constants/formRegister';

const validatorRequiredForAdmin = (value, form, props) =>
  props.isAdmin ? validatorRequired()(value) : undefined;

const validatorRequiredUnlessAvp = (value, form, props) =>
  props.isAvp ? undefined : validatorRequired()(value);

export default createValidation([
  {
    name: formRegisterMeasurementFields.ZIP_CODE,
    validators: [
      (field, form, props) => validatorRequiredUnlessAvp(field, form, props),
      (field, form, props) =>
        props.isAvp ? undefined : validatorNumber()(field),
      (field, form, props) => (props.isAvp ? undefined : validatorZip()(field)),
    ],
  },
  {
    name: formRegisterMeasurementFields.ADDRESS,
    validators: (field, form, props) =>
      validatorRequiredUnlessAvp(field, form, props),
  },
  {
    name: formRegisterMeasurementFields.DISTRICT,
    validators: (field, form, props) =>
      validatorRequiredUnlessAvp(field, form, props),
  },
  {
    name: formRegisterMeasurementFields.CITY,
    validators: (field, form, props) =>
      validatorRequiredUnlessAvp(field, form, props),
  },
  {
    name: formRegisterMeasurementFields.COUNTY,
    validators: (field, form, props) =>
      validatorRequiredUnlessAvp(field, form, props),
  },
  {
    name: formRegisterMeasurementFields.EICZ_CODE,
    validators: (value, form, props) =>
      validatorRequiredForAdmin(value, form, props),
  },
  {
    name: formRegisterMeasurementFields.DISSEMINATION_LEVEL,
    validators: (value, form, props) =>
      props.isProduction ? validatorRequired()(value) : undefined,
  },
]);
